import { createStore, set, type UseStore } from 'idb-keyval';

import { CropPictureHeaderMeta, formatCropPictureHeader } from './crop-picture-header';

const STORE_NAME = 'localCropPictureArchives';

let store: UseStore | undefined;

function getStore(): UseStore {
  if (!store) {
    store = createStore(STORE_NAME, STORE_NAME);
  }
  return store;
}

export type LocalCropPictureArchiveRecord = {
  header: string;
  plotName: string;
  pointNumber: number;
  fieldCode: string;
  name: string;
  type: string;
  lastModified: number;
  blob: Blob;
  savedAt: number;
};

function createArchiveId(meta: CropPictureHeaderMeta): string {
  return `${meta.pointNumber}:${meta.fieldCode}:${Date.now()}`;
}

/** Silent on-device backup when gallery/download is unavailable on PWA. */
export async function saveLocalCropPictureArchive(
  file: File,
  meta: CropPictureHeaderMeta
): Promise<void> {
  const record: LocalCropPictureArchiveRecord = {
    header: formatCropPictureHeader(meta),
    plotName: meta.plotName,
    pointNumber: meta.pointNumber,
    fieldCode: meta.fieldCode,
    name: file.name,
    type: file.type || 'image/jpeg',
    lastModified: file.lastModified || Date.now(),
    blob: file,
    savedAt: Date.now(),
  };

  await set(createArchiveId(meta), record, getStore());
}
